import React, {useEffect, useState } from 'react';
import Button, { CustomButtonProps } from 'components/Basic/Button';
import { useOrgTheme } from 'contexts/ThemeContext';
import useQueriesRunningInBackGround from 'hooks/useQueriesRunningInBackGround';
import { useDispatch, useSelector } from 'react-redux';
import { setSavingState } from 'store/slices/SaveDesignSlice/SaveDesignSlice';
import { RootState } from 'store';
import { selectIsAnyToolActionActive } from 'store/selectors/toolSelector';
import { selectIsRecomputing } from 'store/slices/DsmShadingSlice/selectors';

type SaveDesignBtnProps = CustomButtonProps & {
	designUUID: string;
	isB2C: boolean;
	status: { isLoading: boolean, isError: boolean }
}

const TextLoader = {
	idle: 'Save',
	getEnergy: 'Generating monthly and hourly production data ..',
	saveDesign: 'Saving the production data ..'
};

function SaveDesignBtn(props: SaveDesignBtnProps) {

	const { designUUID, isB2C, status: saveDisgnStatus, disabled, onClick, ...rest } = props;
	const isSaveInProgress = useSelector((state:RootState)=> state.saveDesignState.isSaveInProgress);
	const { saveDesignBtnText } = useOrgTheme();
	const allQueriesRunningInBackGround = useQueriesRunningInBackGround();
	const energyQueriesInProgrss = useQueriesRunningInBackGround([`monthlyDetails-${designUUID}`, `hourlyEnergy-${designUUID}`]);
	const [phase, setPhase] = useState<'idle' | 'getEnergy' | 'saveDesign'>(isSaveInProgress ? 'saveDesign' : 'idle');
	const isRecomputingShading = useSelector(selectIsRecomputing);
	const isAnyToolAcitonActive = useSelector(selectIsAnyToolActionActive);
	const effectivePhase = phase !== 'idle' ? phase : (isSaveInProgress ? 'saveDesign' : 'idle');
	const disableBtn = isRecomputingShading || allQueriesRunningInBackGround || energyQueriesInProgrss
		|| disabled || saveDisgnStatus.isLoading || effectivePhase !== 'idle' || isAnyToolAcitonActive;
	const showLoader = effectivePhase !== 'idle' || energyQueriesInProgrss || saveDisgnStatus.isLoading;

	const dispatch = useDispatch();
	
	useEffect(() => {
		if (saveDisgnStatus.isError) {
			setPhase('idle');
			dispatch(setSavingState(false));
		}
	}, [dispatch, saveDisgnStatus.isError]);

	useEffect(() => {
		let timout: NodeJS.Timeout;
		if (phase === 'getEnergy') {
			timout = setTimeout(() => setPhase('saveDesign'), (30 * 1000)); //10 secs to get enrgy data
		} else if (phase === 'saveDesign') { //80 secs to save production and save design on parent app
			timout = setTimeout(() => setPhase('idle'), (80 * 1000));
		}
		return () => clearTimeout(timout);
	}, [phase]);

	// const showSelectedPanelsErrorToast = useCallback(() => {
	// 	if (previouseToastId?.current) return;
	// 	previouseToastId.current = toast(
	// 		'To move forward, please choose a minimum of three panels',
	// 		{
	// 			progressStyle: {
	// 				background: 'var(--primary)',
	// 			},
	// 			onClose: () => {
	// 				previouseToastId.current = undefined;
	// 			},
	// 		}
	// 	);
	// }, []);

	const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		onClick?.(e);
		if (!isB2C) {
			setPhase('getEnergy');
		}
	};

	const buttonText = effectivePhase === 'idle' ? saveDesignBtnText : TextLoader[effectivePhase];

	return <Button
		className={` ${showLoader ? 'showloader ' : ''} save-btn ipad-save-btn customBtnLoader `}
		disabled={disableBtn}
		showLoader={showLoader}
		onClick={handleClick}
		{...rest}
	>
		<span>
			{showLoader && <span className='loaderSpan'></span>}
			<span></span>
			{buttonText}</span>
		{isB2C && (<svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M7.793 0.292786C7.98053 0.105315 8.23484 0 8.5 0C8.76516 0 
				9.01947 0.105315 9.207 0.292786L13.707 4.79279C13.8945 4.98031 13.9998 
				5.23462 13.9998 5.49979C13.9998 5.76495 13.8945 6.01926 13.707 6.20679L9.207 
				10.7068C9.0184 10.8889 8.7658 10.9897 8.5036 10.9875C8.2414 10.9852 7.99059 
				10.88 7.80518 10.6946C7.61977 10.5092 7.5146 10.2584 7.51233 9.99619C7.51005 
				9.73399 7.61084 9.48139 7.793 9.29279L10.5 6.49979H1C0.734784 6.49979 
				0.48043 6.39443 0.292893 6.20689C0.105357 6.01936 0 5.765 0 5.49979C0 
				5.23457 0.105357 4.98022 0.292893 4.79268C0.48043 4.60514 0.734784 4.49979 1 
				4.49979H10.5L7.793 1.70679C7.60553 1.51926 7.50021 1.26495 7.50021 
				0.999786C7.50021 0.734622 7.60553 0.480314 7.793 0.292786Z" fill="#2E3B68" />
		</svg>)}
	</Button>;
}

export default React.memo(SaveDesignBtn);
